// Extracted from manor-old/stage3.php (inline SVG; embedded images moved to /manor/stage3/).
const scene = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 1917.15 1079.72">
            <g id="BG">
                <image width="1920" height="1080" transform="translate(-1.43)"
                    xlink:href="/manor/stage3/stage3-1.png" />
            </g>
            <g id="Title">
                <image width="1317" height="264" transform="translate(397.62) scale(.85)"
                    xlink:href="/manor/stage3/stage3-2.png" />
            </g>
            <g id="Puzzle_image_frame" data-name="Puzzle image frame">
                <image width="133" height="183" transform="translate(900.74 292.98)"
                    xlink:href="/manor/stage3/stage3-3.png" />
            </g>
            <g id="Tatya">
                <image width="103" height="147" transform="translate(233.85 857.63)"
                    xlink:href="/manor/stage3/stage3-4.png" />
            </g>
            <g id="Jumpscare">
                <image width="1116" height="1080" transform="translate(519.75 195.82) scale(.79)"
                    xlink:href="/manor/stage3/stage3-5.png" />
            </g>
        </svg>`;

export default scene;
